import styled from '@emotion/styled';
import {Grid} from '@mui/material';

export const RefreshButtonGrid = styled(Grid)`
  position: absolute;
  right: 3rem;
  top: 4.3rem;
  z-index: 5;

  @media (max-width: 500px) {
    right: 2rem;
    top: 4.3rem;
  }
`;

export const ButtonsDiv = styled('div')`
  display: flex;
  margin-left: 0.75rem;
`;

export const DocViewContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 88vw;
  height: 85vh;
  #pdf-download,
  #pdf-zoom-out,
  #pdf-zoom-in,
  #pdf-toggle-pagination,
  #pdf-zoom-reset {
    display: none;
  }
`;

export const TextContainer = styled(Grid)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50vh;
  width: 100vh;
  font-weight: bolder;
`;
